import React, {useState} from 'react';
import './style.css';
import api from 'services/api';
import config from 'config';
import {getidusuario} from 'functions/gettabconfig';

const Avaliacao = (props) => {
    const [nroEstrelas, setNroEstrelas] = useState(0);
    const [denAvaliacao, setDenAvaliacao] = useState('');

    const AVALIAR = () => {
        if (getidusuario() === '-1') {
            alert('Você precisa estar logado para avaliar!');
            return;
        }
        if (nroEstrelas === 0) {
            alert('Escolha o número de estrelas!');
            return;
        }
        if (denAvaliacao.trim() === '') {
            alert('Descreva sua opinião!');
            return;
        }
        const avaliacao = { 
            id_estabelecimento: props.dados.id_estabelecimento,
            den_avaliacao: denAvaliacao,
            nro_estrelas: nroEstrelas
        };

        api.post(`${config.ESTABELECIMENTOS_AVALIACAO}`, avaliacao)
        .then(response => {
            if (response.status === 202) {
                setNroEstrelas(0);
                setDenAvaliacao('');
                props.setTrigger(false);
            } else {
                console.log(response.data.erro);
            }
        });
    };

    const CANCELAR =() => {
        setNroEstrelas(0);
        setDenAvaliacao('');
        props.setTrigger(false);
    }

    return (
        <div className='avaliacao-card'>
            <h2 className='section-subtitle'>Avaliar Estabelecimento</h2>
            <div className='avaliacao-form-group'>
                <label>Sua nota:</label>
                <div className="stars-input">
                    {Array.from({ length: 5 }, (_, i) => (
                        <i
                            key={i}
                            className={`fa-star ${nroEstrelas > i ? 'fas' : 'far'}`}
                            onClick={() => setNroEstrelas(i + 1)}
                        ></i>
                    ))}
                </div>
            </div>
            <div className='avaliacao-form-group'>
                <label>Sua opinião:</label>
                <textarea
                    value={denAvaliacao}
                    onChange={(e) => setDenAvaliacao(e.target.value)}
                    placeholder="Conte como foi sua experiência..."
                    className="avaliacao-textarea"
                />
            </div>
            <div className='avaliacao-actions'>
                <button
                    onClick={CANCELAR}
                    className='btn-cancelar'
                >
                    <i className="fas fa-times"></i>
                    Cancelar
                </button>
                <button
                    onClick={AVALIAR}
                    className='btn-enviar'
                >
                    <i className="fas fa-paper-plane"></i>
                    Enviar Avaliação
                </button>
            </div>
        </div>
    );
};

export default Avaliacao;